import { Injectable } from '@angular/core';
import { HttpModelConverter } from 'src/app/modules/core/converter/httpModel.converter';
import { MedicalSterilizationModel } from '../medicalSterilization.model';
import { MedicalSterilizationSummaryConverter } from './medicalSterilizationSummary.converter';
import {
  MedicalDeviceSummaryConverter
} from "../../../../../device/account/api/entity/converter/medicalDeviceSummary.converter";
import {MedicalToolSetSummaryConverter} from "../../../../toolset/api/entity/converter/medicalToolSetSummary.converter";
import {DocumentSummaryConverter} from "../../../../../../document/common/api/converter/documentSummary.converter";

@Injectable({
  providedIn: 'root'
})
export class MedicalSterilizationConverter extends HttpModelConverter<MedicalSterilizationModel> {
  constructor(private summaryConverter: MedicalSterilizationSummaryConverter,
              private medicalDeviceSummaryConverter: MedicalDeviceSummaryConverter,
              private medicalToolSetSummaryConverter: MedicalToolSetSummaryConverter,
              private documentSummaryConverter: DocumentSummaryConverter) {
    super();
  }

  protected createInstance(): MedicalSterilizationModel {
    return new MedicalSterilizationModel();
  }

  protected enrichObject(result: MedicalSterilizationModel, src: MedicalSterilizationModel) {
    result.summary = this.summaryConverter.convert(src.summary);
    result.medicalDevice = this.medicalDeviceSummaryConverter.convert(src.medicalDevice);
    result.instrumentSets = this.medicalToolSetSummaryConverter.convertFromArray(src.instrumentSets);
    result.picture = this.documentSummaryConverter.convert(src.picture);
  }
}

